import React from "react";

import { Edit } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import { Link, LinkProps } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  conceptButton: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: "12px",
    flexDirection: "column",
    padding: theme.spacing(2),
  },
}));

export const SubConceptButton = ({
  label,
  Icon,
  action,
  ...props
}: SubConceptButtonProps) => {
  const { classes } = useStyles();
  if ("onClick" in props) {
    return (
      <Button
        variant="outlined"
        className={classes.conceptButton}
        onClick={() => props.onClick(label)}
      >
        <Icon color="secondary" />
        <Typography
          variant="caption"
          fontWeight={500}
          align="center"
          sx={{ my: 1 }}
        >
          {label}
        </Typography>
      </Button>
    );
  } else {
    return (
      <Button
        variant="outlined"
        component={Link}
        className={classes.conceptButton}
        to={props.linkTo}
      >
        <Icon color="secondary" />
        <Typography
          variant="caption"
          fontWeight={500}
          align="center"
          sx={{ my: 1 }}
        >
          {label}
        </Typography>
      </Button>
    );
  }
};

export type SubConceptButtonProps = LinkConceptProps | ModalConceptProps;

export type LinkConceptProps = {
  label: string;
  Icon: typeof Edit;
  action: "link";
  linkTo: LinkProps["to"];
  disabled?: boolean;
};

export type ModalConceptProps = {
  label: string;
  Icon: typeof Edit;
  action: "click";
  onClick: (label: LinkConceptProps["label"]) => void;
  disabled?: boolean;
};
